import { cn } from "@/lib/cn";

import styles from "./loading-dots.module.css";

export const LoadingDots = ({ color = "#000", className }: { color?: string; className?: string }) => {
  return (
    <span className={cn([styles.loading, className])} role="status" aria-label="Loading">
      <span style={{ backgroundColor: color }} />
      <span style={{ backgroundColor: color }} />
      <span style={{ backgroundColor: color }} />
    </span>
  );
};
